import { gql } from '@apollo/client';

export default gql`
  mutation destroyProductionOrder($input: ProductionOrderDestroyInput!) {
    destroyProductionOrder(input: $input) {
      clientMutationId
      productionOrder {
        id
      }
    }
  }
`;
